import { useState, useEffect, useContext } from 'react';
import { SettingsContext } from '../../contexts/SettingsContext';

export function useCharacterModal(character, onSave, onClose) {
  const { settings } = useContext(SettingsContext);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    systemPrompt: '',
    model: 'claude-3-5-sonnet-20240620',
    maxTokens: settings?.maxTokens || 2000,
    temperature: settings?.temperature || 0.7
  });

  useEffect(() => {
    if (character) {
      setFormData({
        name: character.name || '',
        description: character.description || '',
        systemPrompt: character.systemPrompt || '',
        model: character.model || 'claude-3-5-sonnet-20240620',
        maxTokens: character.maxTokens || settings?.maxTokens || 2000,
        temperature: character.temperature || settings?.temperature || 0.7
      });
    } else {
      setFormData({
        name: '',
        description: '',
        systemPrompt: '',
        model: 'claude-3-5-sonnet-20240620',
        maxTokens: settings?.maxTokens || 2000,
        temperature: settings?.temperature || 0.7
      });
    }
  }, [character, settings]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.systemPrompt.trim()) {
      return;
    }

    setIsLoading(true);
    try {
      await onSave(formData);
      onClose();
    } catch (error) {
      console.error('Error saving character:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      systemPrompt: '',
      model: 'claude-3-5-sonnet-20240620',
      maxTokens: settings?.maxTokens || 2000,
      temperature: settings?.temperature || 0.7
    });
  };

  return {
    formData,
    isLoading,
    handleInputChange,
    handleSubmit,
    resetForm
  };
}
